import { MouseEvent } from 'react';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import CancelIcon from '@mui/icons-material/Cancel';
import { SelectChangeEvent } from '@mui/material/Select';
import { Theme, useTheme } from '@mui/material/styles';
import { SelectOption } from '../types';

interface MultiDropdownProps {
  label: string;
  multipleSelected: string[];
  inputOptions: SelectOption[];
  isReadOnlyView: boolean;
  handleMultipleSelection: (event: SelectChangeEvent<string[]>) => void;
  handleDeleteChipSelection: (e: MouseEvent, value: string) => void;
  renderValidationErrors: () => boolean | JSX.Element;
}

const getStyles = (
  value: string,
  multipleSelected: readonly string[],
  theme: Theme
) => {
  return {
    fontWeight:
      multipleSelected.indexOf(value) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium
  };
};

export default (props: MultiDropdownProps) => {
  const theme = useTheme();

  const {
    label,
    multipleSelected,
    inputOptions,
    isReadOnlyView,
    handleMultipleSelection,
    handleDeleteChipSelection,
    renderValidationErrors
  } = props;

  const getLabelFromValue = (value: string) => {
    const option = inputOptions.find((option) => option.value === value);
    return option?.value;
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={multipleSelected}
        onChange={handleMultipleSelection}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={getLabelFromValue(value)}
                clickable
                disabled={isReadOnlyView}
                color="primary"
                size="small"
                onDelete={(e: MouseEvent) =>
                  handleDeleteChipSelection(e, value)
                }
                deleteIcon={
                  <CancelIcon
                    onMouseDown={(event) => event.stopPropagation()}
                  />
                }
              />
            ))}
          </Box>
        )}
        sx={{
          cursor: 'pointer'
        }}
      >
        {inputOptions.map((option) => (
          <MenuItem
            key={option.id}
            value={option.value}
            style={getStyles(option.value, multipleSelected, theme)}
          >
            {option.value}
          </MenuItem>
        ))}
      </Select>
      {renderValidationErrors()}
    </>
  );
};
